// extracted by mini-css-extract-plugin
export var cardTitle = "_i0-1";
export var commentBubble = "_i0-e";
export var commentForm = "_i0-a";
export var commentInput = "_i0-b";
export var commentLabel = "_i0-d";
export var commentPrompt = "_i0-9";
export var csatCard = "_i0-0";
export var feedbackSection = "_i0-7";
export var starDisabled = "_i0-6";
export var starEmpty = "_i0-5";
export var starFilled = "_i0-4";
export var starWrapper = "_i0-3";
export var starsContainer = "_i0-2";
export var submittedComment = "_i0-c";
export var thankYouText = "_i0-8";